import SortIcon from '@mui/icons-material/Sort'
import { Box, Button, Collapse, Paper } from '@mui/material'
import { Sliders } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import OrderDateFilter from './filters/OrderDateFilter'
import OrderNumberFilter from './filters/OrderNumberFilter'
import PurchasingOrganizationFilter from './filters/PurchasingOrganizationFilter'
import SerialNumberFilter from './filters/SerialNumberFilter'
import PurchaseOrdersSortBy from './PurchaseOrdersSortBy'

/**
 * The PurchaseOrdersFilters component
 * @component
 *
 * @param {Object} props
 * @param {boolean} props.loader
 * @param {function} props.handleClick
  * @param {function} props.handleSortByChange
 * @param {boolean} props.selector_loading
 * @param {Array} props.purchasingOrganizations

 * @returns {JSX.Element}
 */

const PurchaseOrdersFilters = ({
  loader,
  handleClick,
  handleSortByChange,
  selector_loading,
  purchasingOrganizations,
}) => {
  const [expanded, setExpanded] = useState(false)
  const [expandedSort, setExpandedSort] = useState(false)

  const [serie, setSerie] = useState('')
  const [numero, setNumero] = useState('')
  const [orgCompras, setOrgCompras] = useState('')
  const [fechaPedidoDesde, setFechaPedidoDesde] = useState('')
  const [fechaPedidoHasta, setFechaPedidoHasta] = useState('')
  const [ordenarPor, setOrdenarPor] = useState('')

  useEffect(() => {
    handleSortByChange(ordenarPor)
  }, [ordenarPor])

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
          <Button
            sx={{
              color: 'action.active',
              display: 'flex',
            }}
            endIcon={<Sliders size={30} weight={expanded ? 'fill' : 'light'} />}
            onClick={() => setExpanded(!expanded)}
          >
            Filtros
          </Button>
          <Button
            sx={{
              color: 'action.active',
              display: 'flex',
            }}
            endIcon={<SortIcon size={30} weight={expandedSort ? 'fill' : 'light'} />}
            onClick={() => setExpandedSort(!expandedSort)}
          >
            Ordenar
          </Button>
        </Box>
      </Box>
      <Paper sx={{ my: 3 }}>
        <Collapse in={expandedSort}>
          <PurchaseOrdersSortBy sortBy={ordenarPor} handleSortByChange={setOrdenarPor} />
        </Collapse>
        <Collapse in={expanded}>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
              p: 2,
              display: 'flex',
              gap: 0.5,
              flexDirection: 'column',
            }}
          >
            <SerialNumberFilter serialNumber={serie} handleSerialNumber={setSerie} />
            <OrderNumberFilter orderNumber={numero} handleOrderNumber={setNumero} />
            <PurchasingOrganizationFilter
              purchaseOrg={orgCompras}
              handlePurchasingOrg={setOrgCompras}
              purchasingOrganizations={purchasingOrganizations}
              selector_loading={selector_loading}
            />
            <OrderDateFilter
              handleOrderDateFrom={setFechaPedidoDesde}
              handleOrderDateUntil={setFechaPedidoHasta}
            />

            <Button
              disabled={loader}
              variant="contained"
              disableElevation
              sx={{
                ml: 'auto',
                my: 2,
                mb: 4,
                display: 'block',
                width: '100%',
              }}
              onClick={(e) => {
                e.preventDefault()
                handleClick(
                  serie,
                  numero,
                  orgCompras,
                  fechaPedidoDesde,
                  fechaPedidoHasta,
                  ordenarPor,
                )
              }}
            >
              Consultar
            </Button>
          </Box>
        </Collapse>
      </Paper>
    </Box>
  )
}

export default PurchaseOrdersFilters
